<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20.9 19.8h.1a1.1 1.1 0 0 1 0 2.2H3.1a1.1 1.1 0 0 1 0-2.2zm0-9h.1a1.1 1.1 0 0 1 0 2.3H3.1a1.1 1.1 0 1 1 0-2.2zm0-8.8h.1a1.1 1.1 0 0 1 0 2.2H3.1a1.1 1.1 0 1 1 0-2.2z"
    />
  </svg>
</template>
